import { render, staticRenderFns } from "./BulkDeleteIndexesModal.vue?vue&type=template&id=127c919d&"
import script from "./BulkDeleteIndexesModal.vue?vue&type=script&lang=js&"
export * from "./BulkDeleteIndexesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports